import React, { useState, useEffect } from 'react';
import { Truck } from 'lucide-react';
import ModalShell from './ModalShell';

const initialForm = {
  name: '',
  contact: '',
  email: '',
  address: '',
  gstNumber: '',
};

const SupplierModal = ({ isOpen, onClose, onSubmit, editingSupplier }) => {
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    if (isOpen) {
      if (editingSupplier?.id) {
        setFormData({
          name: editingSupplier.name ?? '',
          contact: editingSupplier.contact ?? editingSupplier.phone ?? '',
          email: editingSupplier.email ?? '',
          address: editingSupplier.address ?? '',
          gstNumber: editingSupplier.gstNumber ?? editingSupplier.gst_no ?? '',
        });
      } else {
        setFormData(initialForm);
      }
    }
  }, [isOpen, editingSupplier]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name?.trim()) return;

    onSubmit({
      name: formData.name.trim(),
      contact: formData.contact?.trim(),
      email: formData.email?.trim(),
      address: formData.address?.trim(),
      gstNumber: formData.gstNumber?.trim(),
    });
  };

  if (!isOpen) return null;

  return (
    <ModalShell
      title={editingSupplier?.id ? 'Edit Supplier' : 'Add Supplier'}
      subtitle="Organic produce partner details"
      icon={Truck}
      onClose={onClose}
      footer={(
        <>
          <button type="button" onClick={handleSubmit} className="ui-btn-primary flex-1">
            {editingSupplier?.id ? 'Update Supplier' : 'Add Supplier'}
          </button>
          <button type="button" onClick={onClose} className="ui-btn-secondary flex-1">
            Cancel
          </button>
        </>
      )}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="ui-label">Supplier Name *</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            className="ui-input"
            placeholder="Enter supplier name"
            required
          />
        </div>
        <div>
          <label className="ui-label">Contact Number</label>
          <input
            type="text"
            value={formData.contact}
            onChange={(e) => handleInputChange('contact', e.target.value)}
            className="ui-input"
            placeholder="e.g. 9876543210"
          />
        </div>
        <div>
          <label className="ui-label">Email</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
            className="ui-input"
            placeholder="supplier@example.com"
          />
        </div>
        <div>
          <label className="ui-label">Address</label>
          <input
            type="text"
            value={formData.address}
            onChange={(e) => handleInputChange('address', e.target.value)}
            className="ui-input"
            placeholder="Enter address"
          />
        </div>
        <div>
          <label className="ui-label">GST Number</label>
          <input
            type="text"
            value={formData.gstNumber}
            onChange={(e) => handleInputChange('gstNumber', e.target.value)}
            className="ui-input"
            placeholder="e.g. 33ABCDE1234F1Z5"
          />
        </div>
      </form>
    </ModalShell>
  );
};

export default SupplierModal;
